module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-dialog', {
    attrs: {
      "title": "แจ้งลูกค้าชำระเงิน",
      "visible": _vm.confirmPayment,
      "size": "medium",
      "before-close": _vm.handleClose
    }
  }, [_vm._v("\n    ยินยันการชำระเงินรหัสรายการ\n    "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "cfForm",
    attrs: {
      "model": _vm.cfForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "เลขที่บิล"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.cfForm.billNumber),
      callback: function($$v) {
        _vm.cfForm.billNumber = $$v
      },
      expression: "cfForm.billNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "อัพโหลดรูป"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.imageActionURL,
      "headers": _vm.imageHeaders,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "file-list": _vm.fileList,
      "on-success": _vm.handleImageUploaded,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.imgDialog),
      callback: function($$v) {
        _vm.imgDialog = $$v
      },
      expression: "imgDialog"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImgUrl,
      "alt": ""
    }
  })])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.confirmPayment = false
      }
    }
  }, [_vm._v("ยกเลิก")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.markAsPaid(_vm.cfForm)
      }
    }
  }, [_vm._v("ยืนยัน")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('small', [_vm._v("ค้นหาโดยรหัสรายการ:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "placeholder": "ใส่รหัสรายการที่ต้องการค้นหา"
    },
    on: {
      "input": function($event) {
        _vm.debounceInput('orderNum', _vm.tempFilter.orderNum)
      }
    },
    model: {
      value: (_vm.tempFilter.orderNum),
      callback: function($$v) {
        _vm.tempFilter.orderNum = $$v
      },
      expression: "tempFilter.orderNum"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('small', [_vm._v("ค้นหาโดยเลขที่บิล:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "placeholder": "ใส่เลขที่บิลที่ต้องการค้นหา"
    },
    on: {
      "input": function($event) {
        _vm.debounceInput('billNumber', _vm.tempFilter.billNumber)
      }
    },
    model: {
      value: (_vm.tempFilter.billNumber),
      callback: function($$v) {
        _vm.tempFilter.billNumber = $$v
      },
      expression: "tempFilter.billNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('small', [_vm._v("ค้นหาโดยเบอร์โทรศัพท์:")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "placeholder": "ใส่เบอร์โทรศัพท์ลูกค้าที่ต้องการค้นหา"
    },
    on: {
      "input": function($event) {
        _vm.debounceInput('customerPhoneNumber', _vm.tempFilter.customerPhoneNumber)
      }
    },
    model: {
      value: (_vm.tempFilter.customerPhoneNumber),
      callback: function($$v) {
        _vm.tempFilter.customerPhoneNumber = $$v
      },
      expression: "tempFilter.customerPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('small', [_vm._v("ช่วงเวลาส่งที่ต้องหาค้นหา:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "ช่วงเวลา"
    },
    model: {
      value: (_vm.whereFilter.dateRange),
      callback: function($$v) {
        _vm.whereFilter.dateRange = $$v
      },
      expression: "whereFilter.dateRange"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "type": "gray-light",
      "icon": "close"
    },
    on: {
      "click": _vm.resetFilters
    }
  })], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    staticClass: "filter",
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n      หาโดย:\n      "), _c('a', {
    on: {
      "click": _vm.filterPaid
    }
  }, [_vm._v("บิลที่จ่ายเงินแล้ว")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.filterUnpaid
    }
  }, [_vm._v("บิลที่ยังไม่จ่ายเงิน")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.navigate({
          name: 'order.create'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('order.orderCreate')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.deleteConfirm'),
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('order.deleteConfirmText')) + " " + _vm._s(_vm.selectedOrder.name))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.deleteSelectedOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.confirm')))])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orders,
      "border": "border"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.code'),
      "property": "orderNum"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.orderDate')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(_vm.orders[scope.$index].orderDate, "DD-MM-YYYY")) + "\n      ")]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('customer.name'),
      "property": "customerName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('customer.phoneNumber'),
      "property": "customerPhoneNumber"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.deliveryDate')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("moment")(_vm.orders[scope.$index].deliveryDate, "DD-MM-YYYY")) + "\n      ")]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.billNumber')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [(_vm.orders[scope.$index].billNumber) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.orders[scope.$index].billNumber) + "\n        ")]) : _c('div', [_vm._v("\n          ไม่มีข้อมูล\n        ")])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.totalPrice')
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("formatzero")(_vm.orders[scope.$index].totalPrice)) + " ฿\n      ")]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('order.state'),
      "property": "orderStateText"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "display": "inline-block",
            "border": "0px"
          },
          attrs: {
            "type": "default"
          },
          nativeOn: {
            "click": function($event) {
              _vm.print(_vm.orders[scope.$index])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.orders[scope.$index].orderStatePaid),
            expression: "orders[scope.$index].orderStatePaid"
          }],
          staticStyle: {
            "display": "inline-block",
            "border": "0px"
          },
          attrs: {
            "type": "success"
          },
          nativeOn: {
            "click": function($event) {
              _vm.openPaidDialog(scope.$index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-money"
        })]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "display": "inline-block"
          },
          attrs: {
            "type": "info"
          },
          nativeOn: {
            "click": function($event) {
              _vm.download(_vm.orders[scope.$index])
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-dropdown', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "trigger": "click",
            "size": "small"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('i', {
          staticClass: "el-icon-more"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.navigate({
                name: 'order.edit',
                params: {
                  id: _vm.orders[scope.$index].id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.edit')))]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.confirmDelete(_vm.orders[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.delete')))])], 1)], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "10px 0px",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e54de60a"}!./src/pages/order/view/index.html
// module id = 824
// module chunks = 1